const EVT = 'traderadar:insights-search';

export function emitInsightsSearchQuery(query) {
  window.dispatchEvent(new CustomEvent(EVT, { detail: String(query ?? '') }));
}

export function subscribeInsightsSearchQuery(handler) {
  const wrapped = (e) => handler(e.detail);
  window.addEventListener(EVT, wrapped);
  return () => window.removeEventListener(EVT, wrapped);
}
